import products from './products.js';
import Storage from './storage.js';
import _ from './translate.js';
import { textString } from './texts.js';
import events from './event.js';
import Table from './table.js';
import Logger from './logger.js';

class Paper {
    customizerContentDiv = null;
    attr = null;
    wrapperDiv = null;
    selectProductDiv = null;

    constructor(customizerContentDiv) {
        this.customizerContentDiv = customizerContentDiv;
        if (!this.customizerContentDiv) {
            Logger.error('Paper step failed to load.');
            return;
        }
        this.init();
    }

    async init() {
        await this.createWrapper();
        await this.createTable();
    }

    async createWrapper() {
        if (this.wrapperDiv) {
            // If already initialized, just show the wrapper
            this.wrapperDiv.style.display = 'flex';
            return;
        }
        this.wrapperDiv = document.createElement('div');
        this.wrapperDiv.classList.add('mscp-paper-wrapper');
        this.customizerContentDiv.appendChild(this.wrapperDiv);

        // create select paper div
        this.selectPaperDiv = document.createElement('div');
        this.selectPaperDiv.classList.add('mscp-paper-list');
        this.wrapperDiv.appendChild(this.selectPaperDiv);
    }

    async createTable() {
        // create size list
        const papers = await products.getPapers();
        this.table = new Table({
            wrapperDiv: this.selectPaperDiv,
            'terms': papers,
            'type': 'paper',
            'selectCallback': async (el, value, oldValue) => {
                await events.trigger('updateCropSize');
            },
            'postCreateTitleCallback': async (term) => {
                const price = document.createElement('span');
                price.classList.add('mscp-term-price', 'mscp-column', 'mscp-post-create');
                const fromPrice = await products.getFromPrice(term.value);
                price.textContent = fromPrice ? fromPrice : '';
                return price;
            },
            // TEMP disable matt fibre selection
            // 'selectRule': async (el) => {
            //     const value = el.getAttribute('data-value');
            //     if (value == 'matt-fibre') {
            //         Logger.warn('Matt Fiber is currently unavailable.');
            //         return false;
            //     }
            //     return true;
            // },

        });

        events.add('reInitUpload', () => {
            this.table.deselectAll();
        });

        events.add('setPaperSelection', (value) => {
            this.table.selectItemByValue(value);
        });

    }
}

export default Paper;